module.exports = __webpack_public_path__ + "static/media/5.2886132b.jpg";